// @ts-nocheck
import ActionTypes from '../constants/actions';
import { Record, Set } from "immutable";
import { mergeArraytoSet, addToSet, updateSet, removeFromSet } from "../utils/redux";
import _ from 'lodash';

export const Season = Record({
  _id: "",
  name: "",
  sport: "",
  contestType: "",
  league: "",
  startDate: "",
  active: false
});

export default (state = new Set(), action) => {
  switch (action.type) {
    case ActionTypes.SET_LEAGUES_BY_ORGANIZATION:
    case ActionTypes.SET_ALL_LEAGUES:
      return mergeArraytoSet(action.seasons, state, Season);
    case ActionTypes.UPDATE_LEAGUE:
      if (action.season._id) return updateSet(action.season, state, Season);
    case ActionTypes.ADD_LEAGUE:
    case ActionTypes.SET_SEASON:
      if (action.season._id) return addToSet(action.season, state, Season);
      break;
    case ActionTypes.DELETE_LEAGUE:
      return removeFromSet(action.season, state, Season);
    default:
      return state;
  }
};

